import * as React from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import styled, { withTheme, keyframes } from 'styled-components';
import { rgba } from 'polished';
import * as navigation from '../../state/ducks/navigation';

import { TRANSITION_STATES } from '../primitives/transition';

const op1 = `{ opacity: 1; }`;
const op0 = `{ opacity: 0; }`;
const animateIn = keyframes`
  from ${op0}
  to ${op1}
`;
const animateOut = keyframes`
  from ${op1}
  to ${op0}
`;

class Overlay extends React.Component {
  static Bg = styled.div`
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${props => rgba(props.theme.colors.light, 0.95)};
    z-index: 2;

    opacity: ${props => (props.active ? 1 : 0)};
    animation-name: ${props => (props.active ? animateIn : animateOut)};
    animation-duration: ${props => props.theme.transition.standard}ms;
    animation-timing-function: ease-in-out;
    animation-fill-mode: 'forwards';
  `;
  render() {
    return <Overlay.Bg active={this.props.active} />;
  }
}

class NavigationOverlay extends React.Component {
  render() {
    const { navActive, theme } = this.props;
    return (
      <Transition in={navActive} timeout={theme.transition.standard + 10}>
        {state =>
          state !== TRANSITION_STATES.EXITED && (
            <Overlay
              active={[
                TRANSITION_STATES.ENTERING,
                TRANSITION_STATES.ENTERED,
              ].includes(state)}
            />
          )
        }
      </Transition>
    );
  }
}

const mapStateToProps = state => ({
  navActive: navigation.selectors.isActive(state),
});

export default connect(mapStateToProps)(withTheme(NavigationOverlay));



// WEBPACK FOOTER //
// ./src/components/modules/NavigationOverlay.js